module.exports = {"items":[{"productID":112,"id":"deafultTemplate","title":"Book 20x27","hasCover":false,"minSheets":15,"maxSheets":50,"dimensions":{"pageWidth":400,"pageHeight":150,"margin":{"top":5,"right":5,"bottom":5,"left":5},"spine":{"initialWidth":10,"spineColor":"0x777787","widthIncreasePerPage":2}}}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/templates/templates_fromserver.json
// module id = 867
// module chunks = 0